import styled from "styled-components";

export const Section = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    background: #F8CDDA;
    background: -webkit-linear-gradient(to bottom right, #1D2B64, #F8CDDA);
    background: linear-gradient(to bottom right, #1D2B64, #F8CDDA);
`

export const Container = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    max-width: 1280px;
    padding: 0 20px;
    margin: 0 auto;
`
